var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEltrak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 300,
    height: 100,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#221f1f"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M91.47 91.04h-17V7.59h17zm45.64-14.52v14.14c-3.87 1.2-6.42 1.73-13.58 1.69-2.19-.04-11.69-.6-15.75-7.08-2.93-4.46-2.51-8.35-2.54-15.9V49.6h-8.61V36.23h8.61V20h16.79v16.23h15.08V49.6h-15.08v16.67c0 6.55-.21 12.25 9.38 11.94 1.77-.06 3.7-.58 5.7-1.69m25.97 14.52h-16.61V51.5c0-5.71.1-9.56-.27-15.27h16.88l.04 8.85c5.13-8.61 11.75-11.14 19.06-10v15.09c-3.71-.75-6.61-.6-8.67-.27-8.6 1.39-10.41 8.32-10.41 17.37zm71.99-17.77c0 5.89.26 11.78.51 17.79h-15.97l-.19-7.49c-3.38 5.69-9.47 8.57-16.93 8.57-11.77 0-20.42-5.7-20.42-17.26 0-15.26 15.91-19.02 29.07-19.02 2.78 0 5.68.11 8.47.23-.84-6.53-4.3-9.77-11.43-9.92-5.62 0-9.94 3.03-13.21 6.68l-9.16-9.37c6.88-5.81 15.99-8.71 23.08-8.71 8.86 0 17.68 2.14 22.2 8.59 3.39 4.83 3.61 9.3 3.98 15.45zm-15.15-6.85c-.46-.11-1.04-.11-1.63-.11h-1.75c-7 0-18.44.32-18.44 8.53 0 4.16 4.32 6.51 8.64 6.51 9.33 0 13.18-7.57 13.18-14.93M300 91.04h-21.38L259.9 63.16v27.88h-16.8V7.59h16.8v50.22l18.72-21.58h20.81l-22.62 24.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.15 46.92c-6.88.38-10.69 5.35-11.08 10.51h22.34c.19-5.73-4.39-10.51-10.5-10.51zM11.46 68.88H3.44L0 57.24h11.58C14 44.04 24.05 34.78 40.36 34.78c18.47 0 27.03 13.1 27.03 28.59 0 1.74.15 3.9.02 5.51H28.07c.99 4.03 3.44 10.58 12.8 10.7 6.3.08 10.36-4.34 12.03-6.69l11.84 8.59c-7.2 8.45-16.54 10.9-24.37 10.93-17.5.07-26.61-8.99-28.91-23.53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEltrak);
export default __webpack_public_path__ + "static/media/eltrak.2af1ab3af946cd4e446b184ce055915c.svg";
export { ForwardRef as ReactComponent };